//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ICollectionResponse } from '@apis/collections/ICollectionResponse';
import CollectionEntityType from '@models/CollectionEntityType';

export enum COLLECTIONS_ACTIONS {
  RECEIVE_ADDED_SOURCE_TO_COLLECTION = 'COLLECTIONS/RECEIVE_ADDED_SOURCE_TO_COLLECTION',
  RECEIVE_ADD_SOURCE_TO_COLLECTION_ERROR = 'COLLECTIONS/RECEIVE_ADD_SOURCE_TO_COLLECTION_ERROR',
  REQUEST_ADD_SOURCE_TO_COLLECTION = 'COLLECTIONS/REQUEST_ADD_SOURCE_TO_COLLECTION',
  RECEIVE_CREATE_COLLECTION = 'COLLECTIONS/RECEIVE_CREATE_COLLECTION',
  REQUEST_CREATE_COLLECTION = 'COLLECTIONS/REQUEST_CREATE_COLLECTION',
  CLEAR_CREATED_COLLECTION = 'COLLECTIONS/CLEAR_CREATED_COLLECTION',
  RECEIVE_COLLECTIONS = 'COLLECTIONS/RECEIVE_COLLECTIONS',
  REQUEST_COLLECTIONS = 'COLLECTIONS/REQUEST_COLLECTIONS'
}

export interface ICollectionsState {
  collections?: ICollectionResponse[];
  creatingCollection: boolean;
  createdCollection?: ICollectionResponse;
  collectionAddsPending: ICollectionAdd[];
  collectionAddErrors: ICollectionAddError[];
  requestingCollections: boolean;
}

export interface ICollectionAdd {
  collectionId: string;
  sourceId: string;
  collectionEntityType: CollectionEntityType;
  secondarySourceId: string;
}

export interface ICollectionAddError {
  errorMessage: string;
  addRequest: ICollectionAdd;
}
